const ITEMS = [
  "BUY RARE MINIFIGURES",
  "FREE VALUATIONS IN 24HRS",
  "SELL YOUR COLLECTION",
  "STAR WARS GRAILS",
  "AUTHENTICATED LEGO VAULT",
  "TRADE WITH CONFIDENCE",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-[#121110] py-5 overflow-hidden border-y border-[#B38728]/30" data-testid="marquee-strip">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-mono text-xs uppercase tracking-[0.35em] text-[#F3EDE3]">
                <span className="px-8">{item}</span>
                <span className="gold-text text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
